<template>
  <div v-if="loaded">
    <div class="min-page-height">
      <div class="blog__box" v-if="contentData.header">
        <h1 v-html="contentData.header" class="blog__headline"></h1>
        <h2 v-html="contentData.intro" class="blog__subheadline"></h2>
        <img
          v-if="contentData.img"
          :src="contentData.img"
          class="about__img mb-3"
          alt="o pszczołach"
        />
        <div v-html="contentData.content" class="blog__content"></div>
        <div v-html="contentData.social"></div>

        <div>
          <router-link class="blog__btn" to="/o-pszczolach/">
            Wróć do listy
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      contentData: {},
      pages: [],
      loaded: false,
    };
  },
  inject: ["content"],
  mounted() {
    this.getDataContent();
    this.makeContent();
    window.scrollTo(0, 0);

    // else {
    //   this.$router.push("/404");
    // }
  },

  methods: {
    getDataContent() {
      this.pages = this.content.data.about_bees.articles;
    },
    makeContent() {
      const aboutbees = this.pages;
      const dataContentJson = aboutbees.find(
        (item) => item.index === this.$route.params.id
      );
      if (dataContentJson) {
        this.contentData = dataContentJson;
      }
      this.loaded = true;
      if (dataContentJson.index === "dlaczego-pszczoly-sa-wazne") {
        document.title = "Dlaczego pszczoły są ważne? | Adoptuj Pszczołę";
        document.querySelector('meta[name="description"]').setAttribute("content","Pszczoły są kluczowymi istotami dla naszej planety. Odkryj, dlaczego ich rola w zapylaniu roślin jest niezastąpiona. Poznaj znaczenie pszczelej pracy w naszym artykule!");
      } else if (dataContentJson.index === "co-szkodzi-pszczolom") {
        document.title = "Co szkodzi pszczołom? | Adoptuj Pszczołę";
         document.querySelector('meta[name="description"]').setAttribute("content",": Odkryj, jakie czynniki szkodzą pszczołom i dlaczego ich ochrona jest tak ważna. Zapoznaj się z negatywnym wpływem pestycydów i utratą siedlisk w naszym artykule.");
      } else {
        document.title = "Dlaczego musimy pomóc pszczołom? | Adoptuj Pszczołę";
        document.querySelector('meta[name="description"]').setAttribute("content",": : Pomoc pszczołom - dlaczego to tak ważne? Poznaj kluczowe powody, dla których warto angażować się w ochronę pszczół.");
      }
    },
    scrollToTop() {
      const width = window.innerWidth;
      let heightOfForm = document.getElementById("form__wrapper").scrollHeight;
      if (width > 768) {
        window.scroll({
          top: 0,
          left: 0,
        });
      } else {
        window.scroll({
          top: heightOfForm,
          left: 0,
        });
      }
    },
  },
};
</script>
